/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Needed for redux-saga es6 generator support
import "@babel/polyfill";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router/immutable";
import history from "utils/history";
import "sanitize.css/sanitize.css";
import WebFont from "webfontloader";
import { Workbox } from "workbox-window";
import {parseJwt} from "utils/OauthUtils"
import { getBearer } from "utils/userStorage";
// Import root app
import App from "./containers/App/App";

// Import Language Provider
import LanguageProvider from "./containers/LanguageProvider/LanguageProvider";

// Load the favicon and the .htaccess file
/* eslint-disable import/no-unresolved, import/extensions */
import "!file-loader?name=[name].[ext]!./images/favicon.ico";
import "file-loader?name=.htaccess!./.htaccess";
/* eslint-enable import/no-unresolved, import/extensions */
import configureStore from "./configureStore";

// Import i18n messages
import { DEFAULT_LOCALE, translationMessages } from "./i18n";
import { setMomentLocale } from "utils/Date";

setMomentLocale(DEFAULT_LOCALE);

window.orderDisabled = false

WebFont.load({
  google: {
    families: ["Jura", "Roboto", "sans-serif"],
  },
});

var debugMode = location.href.includes("localhost")
window.debugMode = debugMode
// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById("app");

setInterval(() => {
    //check for threeshape expiration
    
    //dit gaat fout

    
    //should only attempt this if connected to 3shape
    if(localStorage.getItem('jwt')){
      // console.log('refresh request done')
      fetch(`${__URLS__["api"]}admin/RefreshOauth`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getBearer()}`,
          },
          body:JSON.stringify({})
      }).then(res => res.text()).then(data => {
        // console.log('refresh request succesfull')
        // var jwtdata = parseJwt(threeresponse.idToken)
        // localStorage.setItem('jwt',JSON.stringify(jwtdata))
      })

    }

    // var jwtdata = window.jwt
    // if(!jwtdata){
    //   return
    // }
    // if((Date.now() / 1000) > jwtdata.exp){
    //   //expired
    //   //if soon to be expired do an auto refresh
    //   //if fully expired have the user do a login
    // }else{
    //   console.log('refresh request done')
    //   fetch(`${__URLS__["api"]}admin/RefreshOauth`, {
    //       method: 'POST',
    //       headers: {
    //         "Content-Type": "application/json",
    //         "Authorization": `Bearer ${getBearer()}`,
    //       },
    //       body:JSON.stringify({})
    //   }).then(res => res.text()).then(data => {
    //     console.log('refresh request succesfull')
    //     var threeresponse = JSON.parse(data)
    //     // var jwtdata = parseJwt(threeresponse.idToken)
    //     // localStorage.setItem('jwt',JSON.stringify(jwtdata))
    //   })
    // }
}, 60*1000);//every minute



const render = messages => {
  if (!global.Intl) {
    require.ensure(["intl", "intl/locale-data/jsonp/en.js"], require => {
      require("intl");
      require("intl/locale-data/jsonp/en.js");
      runApp(messages);
    });
  } else {
    runApp(messages);
  }
};

function runApp(messages) {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE,
  );
}

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(["./i18n", "./containers/App/App"], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise(resolve => {
    resolve(import("intl"));
  })
    .then(() => Promise.all([import("intl/locale-data/jsonp/en.js")]))
    .then(() => render(translationMessages))
    .catch(err => {
      throw err;
    });
} else {
  render(translationMessages);
}

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
if (process.env.NODE_ENV === "production") {
  if ("serviceWorker" in navigator) {
    const wb = new Workbox("/sw.js");

    wb.addEventListener("activated", () => {
      window.location.reload();
    });

    wb.register().then(r => {
      setInterval(() => {
        r.update();
      }, 1000 * 60 * 5);
    });
  }
}
